// extracted by mini-css-extract-plugin
export default {"modal":"Error-module__modal___bjShY","text":"Error-module__text___nnEcr","header":"Error-module__header___nE0X1"};